<div class="header" [class.is-mobile]="mobileQuery.matches">
  <div class="logo">
    <a routerLink="/">
      <img src="../assets/Hubmedical_logo_PNG.png" alt="Logo" width="140px" />
    </a>

    @if(!mobileQuery.matches){
    <span class="text-header"> Conexões Entre os Consultas de Saúde</span>
    }
  </div>

  <div class="menu">
    <img src="../assets/icons/icon_login.svg" (click)="login()" alt="Login" width="220px" />
  </div>
</div>

<div class="container" [class.is-mobile]="mobileQuery.matches">
  <div class="capa">
    <div class="capa-content">
      <div class="beta">
        <img src="../assets/HomeHeroVersaoBeta.png" alt="versão beta" />
      </div>
      <div class="hero-text-container">
        <div class="title-capa" [ngClass]="deviceService.isMobile() ? 'title-capa-mobile' : ''">
          Conectamos profissionais da saúde às melhores oportunidades do mercado
        </div>

        <div class="subtitle-capa" [ngClass]="deviceService.isMobile() ? 'subtitle-capa-mobile' : ''">
          A solução completa para médicos, hospitais e prestadores de serviços de
          saúde.
        </div>
      </div>
      <!-- <div class="cta">
        <button>Cadastre-se agora gratuitamente</button>
      </div> -->
    </div>
  </div>

  <div class="section-space" [class.is-mobile]="mobileQuery.matches">
    <div class="section-space-container">
      <div class="section-space-card">
        <div class="section-space-card-title">Cadastro Validado</div>
        <div class="section-space-card-text">
          Profissionais e empresas se cadastram com documentos verificados,
          garantindo segurança e confiança.
        </div>

        <div class="section-space-card-img">
          <img src="assets/icons/icon_comofazer_1.svg" alt="Ícone cadastro validado" />
        </div>
      </div>
      <div class="section-space-card">
        <div class="section-space-card-title">Verificação Inteligente</div>
        <div class="section-space-card-text">
          Integração com conselhos e órgãos oficiais e revisão por atendentes do
          HubMedical
        </div>
        <div class="section-space-card-img">
          <img src="assets/icons/icon_comofazer_2.svg" alt="Ícone verificação inteligente" />
        </div>
      </div>

      <div class="section-space-card">
        <div class="section-space-card-title">Conexão segura</div>
        <div class="section-space-card-text">
          Busque ou publique serviços com segurança e receba alertas de validade
          documental.
        </div>

        <div class="section-space-card-img">
          <img src="assets/icons/icon_comofazer_3.svg" alt="Ícone conexão segura" />
        </div>
      </div>
    </div>
  </div>

  <div class="section-info" [class.is-mobile]="mobileQuery.matches">
    <div class="section-info-content">
      <div class="section-info-logo">
        <img src="assets/Home_section-info_logo.svg" alt="Logo HubMedical" />
      </div>
      <div class="section-info-text">
        <p>
          O HubMedical é uma plataforma digital que conecta profissionais da
          saúde e estabelecimentos certificados em todo o Brasil. Nosso
          compromisso é garantir relações seguras, transparentes e legalmente
          verificadas no setor da saúde.
        </p>
        <p>
          Com um sistema robusto de validação documental e gestão de ofertas e
          demandas, tornamos o processo de contratação e prestação de serviços
          mais ágil, confiável e seguro.
        </p>
      </div>
    </div>
  </div>

  <div class="section-responsive">
    <div class="section-responsive-content">
      <h2 class="section-title">Tecnologia que Simplifica sua Rotina</h2>
      <div class="responsive-flex-container">
        <div class="section-responsive-logo">
          <img src="assets/AplicativoTelas.png" alt="Telas do aplicativo HubMedical" class="app-screens-img" />
        </div>
        <div class="section-responsive-text">
          <div class="feature-heading">
            <h3>Facilidade de uso</h3>
            <p>Design clean, navegação intuitiva e foco em resultado.</p>
          </div>

          <div class="features-grid">
            <div class="feature-item">
              <div class="feature-icon">
                <img src="assets/icons/icon_certificados.svg" alt="verificado" />
              </div>
              <p>Cadastro simples e verificado</p>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <img src="assets/icons/icon_ofertas.svg" alt="busca" />
              </div>
              <p>Buscas e ofertas em tempo real</p>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <img src="assets/icons/icon_shareDoc.svg" alt="documentos" />
              </div>
              <p>Gestão e compartilhamento de documentos</p>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <img src="assets/icons/icon_notif.svg" alt="alertas" />
              </div>
              <p>Alertas automáticos de validade</p>
            </div>
          </div>

          <div class="cta-container">
            <button class="cta-button" (click)="login()">
              Experimente agora
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-shopping-card></app-shopping-card>

  <div class="section-faq" [class.is-mobile]="mobileQuery.matches">
    <div class="section-faq-header">
      <div class="faq-icon">
        <img src="assets/icons/icon_home_FAQ.svg" alt="Ícone perguntas frequentes" />
      </div>
      <div class="faq-intro-text">
        Aqui estão algumas das perguntas mais feitas pelos nossos usuários. Para uma versão mais compreensiva da ajuda,
        acesse a seção de perguntas mais frequentes (FAQ) no link à esquerda, e caso já seja assinante e ainda não
        encontre a
        resposta para a sua dúvida, entre em contato com o nosso SAC no link mais abaixo.
      </div>
    </div>

    <div class="faq-grid">
      <!-- Primeira coluna -->
      <div class="faq-column">
        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>O que é a HubMedical?</strong>
          </div>
          <div class="faq-answer">
            É uma plataforma digital que conecta profissionais da saúde e instituições certificadas, promovendo
            oportunidades seguras e verificadas.
          </div>
        </div>

        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>Quem pode se cadastrar?</strong>
          </div>
          <div class="faq-answer">
            Profissionais da saúde registrados em conselhos regionais e estabelecimentos com cadastro ativo no CNES.
          </div>
        </div>

        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>Preciso pagar para usar a HubMedical?</strong>
          </div>
          <div class="faq-answer">
            Não. Durante a versão Beta, o acesso é totalmente gratuito. Após essa fase, haverá planos anuais
            com pagamento mensal e 30 dias gratuitos para novos usuários.
          </div>
        </div>

        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>Quais perfis estão disponíveis?</strong>
          </div>
          <div class="faq-answer">
            Você pode se cadastrar como Profissional da Saúde (Pessoa Física), Estabelecimento de Saúde
            (Pessoa Jurídica) ou Contratante de Consultas.
          </div>
        </div>

        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>Como funciona a verificação de documentos?</strong>
          </div>
          <div class="faq-answer">
            A validação é feita por meio de integração com órgãos oficiais e revisão por atendentes
            especializados do HubMedical.
          </div>
        </div>
      </div>

      <!-- Segunda coluna -->
      <div class="faq-column">
        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>A plataforma avisa quando meus documentos estão vencendo?</strong>
          </div>
          <div class="faq-answer">
            Sim. Todos os perfis recebem alertas automáticos sobre vencimento de documentos.
          </div>
        </div>

        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>Instituições podem buscar profissionais?</strong>
          </div>
          <div class="faq-answer">
            Sim. Estabelecimentos e contratantes podem pesquisar perfis verificados e publicar demandas.
          </div>
        </div>

        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>Posso publicar minhas ofertas de consultas e procedimentos?</strong>
          </div>
          <div class="faq-answer">
            Sim. Profissionais podem criar e gerenciar suas próprias ofertas diretamente na plataforma, desde
            que estejam com sua documentação em dia e validada.
          </div>
        </div>

        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>A HubMedical garante os acordos entre usuários?</strong>
          </div>
          <div class="faq-answer">
            Não. A plataforma valida documentos e facilita conexões, mas não se responsabiliza por acordos
            firmados entre as partes.
          </div>
        </div>

        <div class="faq-item">
          <div class="faq-question">
            <img src="assets/icons/icon_home_FAQ.svg" alt="FAQ" class="faq-question-icon" />
            <strong>Como posso acessar o HubMedical?</strong>
          </div>
          <div class="faq-answer">
            Via navegador ou instalando o aplicativo PWA em seu dispositivo móvel ou desktop. O acesso é
            simples e seguro.
          </div>
        </div>
      </div>
    </div>
      <div class="sac-support-container">
        <img class="sac-support-image" src="assets/SAC-SuporteSempreDiponivel.png"
          alt="SAC - Suporte Sempre Disponível" />
      </div>
  </div>
</div>
  <div class="section-footer">
    <div class="section-footer-content">
      <div class="footer-main">
        <div class="footer-logo-section">
          <div class="footer-logo">
            <img src="assets/Hubmedical_logo_PNG.png" alt="HubMedical Logo" />
          </div>
          <div class="footer-tagline">
            Conexões Entre os Serviços de Saúde
          </div>
          <div class="footer-address">
            <p>Rua Corticeira da Serra, nº 71 , Florianópolis/SC</p>
            <p>CEP: 88.056-368 - CNPJ: 27.390.450/0001-94</p>
          </div>
        </div>

        <div class="footer-contact">
          <div class="contact-item">
            <img src="assets/icons/whatsapp-icon.svg" alt="WhatsApp" class="contact-icon" />
            <span>(48) 99107 4004</span>
          </div>

          <div class="contact-item">
            <img src="assets/icons/instagram-icon.svg" alt="Instagram" class="contact-icon" />
            <span>&#64;HUBmedical</span>
          </div>

          <div class="contact-item">
            <img src="assets/icons/email-icon.svg" alt="Email" class="contact-icon" />
            <span>atendimento&#64;hubmedical.com.br</span>
          </div>

          <div class="contact-item">
            <img src="assets/icons/facebook-icon.svg" alt="Facebook" class="contact-icon" />
            <span>hubmedical</span>
          </div>
        </div>

        <div class="footer-links">
          <h6>Links Úteis</h6>
          <div class="footer-links-list">
            <button type="button" class="footer-link" (click)="openTermsDialog()" aria-label="Ver Termos e Regras de Uso">Termos de Uso</button>
            <button type="button" class="footer-link" (click)="openPrivacyPolicyDialog()" aria-label="Ver Política de Privacidade">Política de Privacidade</button>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-copyright">
          <p>&copy; 2024 HubMedical. Todos os direitos reservados.</p>
          <!-- <p>CNPJ: 27.390.450/0001-94</p> -->
        </div>
      </div>
    </div>
  </div>

